import { HelpFeature } from '@/model/HelpModel';
import React from 'react';
import { HeaderTitleBar, HelpFactoryComponent, ReportingIcon } from '../../components/common';
import { EventTable } from '../../components/event';
import { Reports } from '../../components/reports';
import { User } from '../../model/AccountModel';
import { Logger } from '../../model/LoggingModel';

// Internal state for the component
interface State {}

// Normal properties for the component
interface OwnProps {}

// combine them together
type Props = OwnProps;

//Avoid creating object style inline, since increases reconciliations
const user: User = getUser();
const { showEventsOnReportingPage } = user;
const topicId: string = 'ReportingTab';

class ReportsPage extends React.Component<Props, State> {
	constructor(prop) {
		super(prop);
	}

	componentDidCatch(error, errorInfo) {
		Logger.writeErrorLog(`${error}: ${errorInfo}`);
	}

	render() {
		return (
			<>
				<HeaderTitleBar
					id='reportingContainer'
					title={_('Reporting')}
					icon={<ReportingIcon />}
					helpButton={<HelpFactoryComponent helpFeature={HelpFeature.Reporting} topicId={topicId} isLight size='medium' />}
				/>
				<Reports />
				{showEventsOnReportingPage && <EventTable />}
			</>
		);
	}
}

export { ReportsPage };
